import React from "react"
import { Box, Typography } from "@mui/material"
import { KnownSource } from "../../../../types/Source"
import { tonalPalettes } from "@zuto/theme/src/mui/Colors"

type FormlessJourneyProps = {
  source: KnownSource
  shouldShowWhereApplicationIsFrom: boolean
}

const SOURCE_BRAND_COLOURS: Partial<Record<KnownSource, string>> = {
  carmoola: "#f90081"
}

const getSourceColour = (source: KnownSource): string =>
  SOURCE_BRAND_COLOURS[source] ?? tonalPalettes.primary[40]

const DEFAULT_BODY_COPY =
  "We've received your application, and your dedicated Zuto Car Buying Expert will give you a call shortly to discuss next steps."

const SOURCE_BODY_COPY: Partial<Record<KnownSource, string>> = {
  carmoola:
    "We'll give you a quick call 🤙 to talk through your options. In the meantime, continue to your Zuto account to view your online decision.",
  experian:
    "Your dedicated Zuto Car Buying Expert will give you a call shortly to discuss next steps. In the meantime, continue to your Zuto account."
}

const getBodyCopy = (source: KnownSource): string =>
  SOURCE_BODY_COPY[source] ?? DEFAULT_BODY_COPY

export const RecievedApplicationText = ({
  source,
  shouldShowWhereApplicationIsFrom
}: FormlessJourneyProps) => {
  return (
    <Box pl={5} pr={5}>
      {shouldShowWhereApplicationIsFrom && (
        <Typography
          variant="bodyLarge"
          component="p"
          textAlign="left"
          mb={5}
        >
          We&apos;ve received your application from{" "}
          <Typography
            component="span"
            sx={{ color: getSourceColour(source), fontWeight: 600 }}
          >
            {source}
          </Typography>{" "}
          and we&apos;re checking our panel of lenders.
        </Typography>
      )}
      <Typography variant="bodyLarge" component="p" textAlign="left">
        {getBodyCopy(source)}
      </Typography>
    </Box>
  )
}
